import { Stack, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import RecentProjectsLinkComponent from '../components/Architecture/RecentProjectsLinkComponent'
import FilesListComponent from '../components/Architecture/FilesListComponent'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { useSelector } from 'react-redux'
import { Project } from '../models/Organization'
import HistoryHandlersComponent from '../HistoryHandlersComponent'

const projectsSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.projects,
)
const selectedClientSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedClient,
)
const selectedFileSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedFile,
)

function Files() {
  const { projectId } = useParams<{ projectId: string }>()
  const navigate = useNavigate()
  const projects = useSelector(projectsSelector)
  const selectedClient = useSelector(selectedClientSelector)
  const selectedFile = useSelector(selectedFileSelector)
  const [project, setProject] = useState<Project>()

  const location = useLocation()
  const pathItems = location.pathname.split('/')
  if (pathItems.length > 0) {
    pathItems.pop()
  }
  const newPathname = pathItems.join('/')

  useEffect(() => {
    if (projectId) {
      const parsedId = Number.parseFloat(projectId) as any
      const existingProject = projects.find(
        (project) => project.id === parsedId,
      )
      if (existingProject) {
        setProject(existingProject)
      } else {
        navigate(newPathname)
      }
    } else {
      navigate(newPathname)
    }
  }, [projectId])

  return (
    <Box
      gap={'2.5rem'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Stack spacing='1rem' height='100%'>
        <HistoryHandlersComponent />
        <Box
          display='flex'
          width='100%'
          gap='2rem'
          alignItems='center'
          justifyContent='space-between'
        >
          {project && (
            <Typography
              sx={{
                color: '#06004A',
                fontSize: '0.94rem',
                fontWeight: 500,
                lineHeight: 'normal',
              }}
            >
              {`${selectedClient ? `${selectedClient?.name} > ` : ''} ${project?.name} ${selectedFile ? `> ${selectedFile?.name}` : ''}`}
            </Typography>
          )}
          <RecentProjectsLinkComponent />
        </Box>
        {!!project && <FilesListComponent project={project} />}
      </Stack>
    </Box>
  )
}

export default Files
